var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',[_c('b-tab',{attrs:{"active":"","title":"Profile"}},[_c('UsersView')],1),(_vm.$can('read', 'ACL'))?_c('b-tab',{attrs:{"title":"Billing & Plans"}},[_c('BillingPlans')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }